
export type ProjectSecretGeneric<ID = string, D = string> = {
  _id: ID,
  projectId: ID,
  description: string,
  name: string,
  created: D,
  updated: D,
  createdBy: string,
  updatedBy: string
}

export const projectSecretPlaceHolderByName = (secretName: string) => {
  return `_SECRET_${secretName}_`;
}